(() => {
  const source = document.getElementById('GooseMarlboroGallery');
  if (!source) return;
  const config = JSON.parse(source.textContent);
  const originals = ['marlboro-9298421.png', 'marlboro-8571053.png', 'marlboro-138342.jpg', 'marlboro-397103.jpg', 'marlboro-negro-detalle-herraje.webp', 'marlboro-negro-detalle-interior.webp', 'marlboro-negro-original-dsc2933.webp', 'marlboro-negro-original-dsc2533.webp', 'marlboro-negro-original-dsc2552.webp', 'marlboro-negro-original-dsc2928.webp', 'marlboro-negro-original-dsc2540.webp'];
  let previousColor;
  let previousGallery;
  let previousViewer;
  const sync = () => {
    const root = document.querySelector('[id^="MainProduct-"]');
    const gallery = root?.querySelector('media-gallery[data-goose-scroll]');
    if (!gallery) return;
    const id = root.querySelector('product-form form input[name="id"]')?.value || config.initialVariant;
    const color = config.variants[id];
    if (!color) return;
    if (color === previousColor && gallery === previousGallery && gallery.johnScroll === previousViewer) return;
    previousColor = color;
    previousGallery = gallery;
    previousViewer = gallery.johnScroll;
    document.documentElement.dataset.gooseMarlboroColor = color;
    const items = [...gallery.querySelectorAll('.product__media-item[data-media-id]')];
    const filename = item => item.querySelector('img')?.src.split('/').pop().split('?')[0];
    const find = name => items.find(item => filename(item) === name);
    const photos = color === 'negro' ? originals : ['frontal', 'posterior', 'superior', 'interior', 'detalle-herraje', 'detalle-interior'].map(view => `marlboro-${color}-${view}.webp`);
    const videos = items.filter(item => item.querySelector('deferred-media, video, iframe'));
    const ordered = [...photos.map(find), ...(color === 'negro' ? videos : [])].filter(Boolean);
    if (!ordered.length) return;
    const thumbs = [...gallery.querySelectorAll('.thumbnail-list__item[data-target]')];
    const list = gallery.querySelector('[id^="Slider-Gallery"]');
    // Video thumbnails contain a poster rather than a video element.
    thumbs.forEach(thumb => {
      const shown = ordered.some(item => item.dataset.mediaId === thumb.dataset.target);
      thumb.style.setProperty('display', shown ? 'block' : 'none', 'important');
    });
    [...ordered].reverse().forEach(item => {
      list?.prepend(item);
      const thumb = thumbs.find(entry => entry.dataset.target === item.dataset.mediaId);
      if (thumb) thumb.parentElement.prepend(thumb);
    });
    if (color !== 'negro') videos.forEach(item => item.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); }));
    gallery.johnScroll?.refresh();
    gallery.setActiveMedia?.(ordered[0].dataset.mediaId, false);
    gallery.querySelectorAll('slider-component').forEach(slider => slider.resetPages?.());
  };
  const schedule = () => { sync(); requestAnimationFrame(sync); setTimeout(sync, 100); setTimeout(sync, 350); };
  document.addEventListener('change', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('shopify:section:load', () => { previousGallery = null; schedule(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  setInterval(() => { if (!document.hidden) sync(); }, 250);
  schedule();
})();
